"use strict";
/*
 * Created on 04.01.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author MSu
 */


var ActionFeasibility =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ActionFeasibility, _DomainObject_1$Domai);

  function ActionFeasibility(actionType) {
    var _this;

    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : immutable_1.List.of();
    var validationResult = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, ActionFeasibility);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActionFeasibility).call(this));
    _this.actionType = actionType;
    _this.tags = tags;
    _this.validationResult = validationResult;
    return _this;
  }

  _createClass(ActionFeasibility, [{
    key: "omitMessageKeys",
    value: function omitMessageKeys(keys) {
      var filteredObjects = this.validationResult.resultObjects.filter(function (ro) {
        return !keys.has(ro.messageKey);
      });
      return this.copy('validationResult', this.validationResult.copy('resultObjects', filteredObjects));
    }
  }, {
    key: "allowed",
    get: function get() {
      return this.validationResult.isSuccessful();
    }
  }]);

  return ActionFeasibility;
}(DomainObject_1.DomainObject);

exports.ActionFeasibility = ActionFeasibility;